export default __webpack_public_path__ + "static/media/Gloves of Righteous Smiting.2753392b.jpg";